import { render } from "./BotTFAQs.vue?vue&type=template&id=3e07a51e"
import script from "./BotTFAQs.vue?vue&type=script&lang=js"
export * from "./BotTFAQs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__